import { useCallback, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #3567 -- Score Admin's "Place by the rules". `preview` runs score-api's
// dry run of the auto-placer (writes nothing); `commit` re-runs it and writes
// only if it still proposes exactly the placings the person confirmed (else a
// 409 place_by_rules_changed / place_by_rules_unavailable the caller handles).
export function usePlaceByRules() {
  const scoreApi = useScoreApi();
  const [committing, setCommitting] = useState(false);

  const preview = useCallback(
    async (classId) => unwrap(await scoreApi.results.previewPlaceClassByRules(classId)),
    [scoreApi],
  );

  const commit = useCallback(
    async (classId, placings) => {
      setCommitting(true);
      try {
        return unwrap(await scoreApi.results.commitPlaceClassByRules(classId, { placings }));
      } finally {
        setCommitting(false);
      }
    },
    [scoreApi],
  );

  return { preview, commit, committing };
}

export default usePlaceByRules;
